import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

export default function LoginCard() {
    const { t } = useLang('membersday.logincard');
    const router = useRouter();

    const onLocationTo = (path: string) => {
        router.push(`/${router.locale}/${path}`);
    };

    return (
        <div className={styles.LoginCard}>
            <div className="LoginCard-content">
                <div className="title">{t('title')}</div>
                <div
                    className="register-button"
                    onClick={() => {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'ecocredits_button',
                            type: 'Register',
                            list_name: t('title'),
                            button_name: t('button_name'),
                        });
                        onLocationTo('register');
                    }}
                >
                    {t('button_name')}
                </div>
                <div className="button-bottom-tip">
                    {t('button_bottom_tip')}
                    <span
                        className="login-button"
                        onClick={() => {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'ecocredits_button',
                                type: 'Login',
                                list_name: t('title'),
                                button_name: t('button_bottom_tip_login'),
                            });
                            onLocationTo('login');
                        }}
                    >
                        {t('button_bottom_tip_login')}
                    </span>
                </div>
            </div>
        </div>
    );
}
